import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  messages: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_AI_ASSISTANT:
      return {
        ...state,
        isFetching: true,
        messages: [...state.messages, action.message],
      }

    case ActionTypes.RECEIVE_AI_ASSISTANT:
      return {
        ...state,
        isFetching: false,
        messages: [...state.messages, action.message],
      }

    case ActionTypes.DELETE_MSG_AI_ASSISTANT:
      return {
        isFetching: false,
        messages: [],
      }

    default:
      return state
  }
}